import {
  DriverCandidatureActiveErrorType,
  DriverCandidatureNotActiveError,
} from "./driver-candidature-active-error";

const createNotActiveError = (): DriverCandidatureNotActiveError => {
  return {
    message: "",
    params: "",
    type: DriverCandidatureActiveErrorType.NOT_ACTIVE,
  };
};

const driverCandidatureActiveErrorFactory = {
  createNotActiveError,
};

export default driverCandidatureActiveErrorFactory;
